import { useEffect, useState } from "react";
import { collection, query, where } from "firebase/firestore";
import { firestore } from "../shared/FirebaseConfig";
import { EMERGENCIES } from "../shared/emergencyData";
import { resilientOnSnapshot } from "../shared/resilientSnapshot";
import { useUser } from "../shared/UserContext";

// Live subscription to the school's active emergency (or null). schoolId-scoped so the
// security rules authorize it; equality+equality query needs no composite index.
// Uses the resilient listener so a stale-token blip self-heals instead of leaving the
// emergency board frozen (safety-critical path).
export default function useActiveEmergency() {
  const { schoolId } = useUser();
  const [emergency, setEmergency] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!schoolId) { setEmergency(null); setLoading(false); return; }
    setLoading(true);
    return resilientOnSnapshot(
      query(
        collection(firestore, EMERGENCIES),
        where("schoolId", "==", schoolId),
        where("isActive", "==", true),
      ),
      snap => {
        const d = snap.docs[0];
        setEmergency(d ? { id: d.id, ...d.data() } : null);
        setLoading(false);
      },
      "useActiveEmergency",
    );
  }, [schoolId]);

  return { emergency, loading };
}
